import "./bootstrap"; // require can't be used so this was auto-rewritten
import "../css/app.css";

/*
A lot of trouble with fonts from fontawesome. Details:
	1st => no '~' prefix in path tolerated! So import "~@fortawesome..." errors-out
	2nd => if you import within app.css, then fonts URL(..) errors-out
	3rd => various fix-es to webpack.mix.js from web don't help
	4th => none use postcss-import extension to postcss! (or are for SASS)
All you can do is move import of fontawesome out of *.css files and thus here!
*/
import "@fortawesome/fontawesome-free/css/all.css";


import { createApp, h } from 'vue';
import { createInertiaApp/*, Link, Head */ } from '@inertiajs/inertia-vue3';

import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { Ziggy } from "./ziggy-routes.js"; // eah the generated routes file

import { InertiaProgress } from '@inertiajs/progress';

InertiaProgress.init({ color: '#4B5563' });


const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

// sorry this plugin isn't present since we are using WebPack and not Vite to load components here!
// import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

const startNode = document.getElementById("vueApp");

createInertiaApp({
	title: (title) => `${title} - ${appName}`,
	//resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
	resolve: async (name) =>{ return (await import(`./vue-files/page-bases/${name}`)).default; },
	setup({ el, app, props, plugin }) {
		return createApp({ render: () => h(app, props) })
			.use(plugin)
			.use(ZiggyVue, Ziggy)
			//.component("Link", Link)
			//.component("Head", Head)
			.mixin({ methods : { route } })
			.mount(startNode);
	},
});
